import { isNativeMobileApp } from './mobileApp';
import { getToken } from '../services/authApi';

/** Domain web production (trang chủ quản lý đầy đủ). */
export function getWebAppBaseUrl(): string {
  const fromEnv = import.meta.env.VITE_WEB_BASE_URL?.trim();
  if (fromEnv) {
    return fromEnv.replace(/\/+$/, '');
  }
  if (typeof window !== 'undefined') {
    const host = window.location.hostname;
    if (host === 'localhost' || host === '127.0.0.1') {
      return `${window.location.protocol}//${window.location.host}`;
    }
  }
  return 'https://quanlynhakcn.com';
}

/** Mở web quản lý — giữ phiên đăng nhập qua mobile-session bridge (không cần đăng nhập lại). */
export function openWebManagement(redirectPath = '/profile'): void {
  const token = getToken();
  const webBase = getWebAppBaseUrl();
  const safeRedirect = redirectPath.startsWith('/') ? redirectPath : '/profile';

  if (!isNativeMobileApp()) {
    window.location.href = token ? safeRedirect : '/auth/login';
    return;
  }

  if (!token) {
    window.location.href = `${webBase}/auth/login`;
    return;
  }

  const bridgeUrl = new URL('/auth/mobile-session', webBase);
  bridgeUrl.searchParams.set('token', token);
  bridgeUrl.searchParams.set('redirect', safeRedirect);
  window.location.assign(bridgeUrl.toString());
}

/** Mở trang điều kiện và điều khoản trên web. */
export function openWebPolicy(): void {
  const url = `${getWebAppBaseUrl()}/policy`;

  if (isNativeMobileApp()) {
    window.open(url, '_blank', 'noopener,noreferrer');
    return;
  }

  window.location.assign(url);
}

/** Mở trang đăng ký thuê phòng (QR phòng) trên web — không hỗ trợ trong APK. */
export function openWebPayRoom(roomCode: string): void {
  const webBase = getWebAppBaseUrl();
  const url = `${webBase}/pay/${encodeURIComponent(roomCode)}`;

  if (isNativeMobileApp()) {
    window.open(url, '_blank', 'noopener,noreferrer');
    return;
  }

  window.location.assign(url);
}
